import React, { useState, useEffect, useContext } from 'react';
import AuthService from '../../../../../services/AuthService';
import AuthContext from '../../../../../context/Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import styles from '../../formF.module.css';

const FormSPFisico = ({ certificadosSelecionados, onBack }) => {
    const { user, setUser } = useContext(AuthContext);
    console.log("Current user:", user);
    const [nomeCompleto, setNomeCompleto] = useState('');
    const [cpf, setCpf] = useState('');
    const [rg, setRg] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [genero, setGenero] = useState('');
    const [nomeMae, setNomeMae] = useState('');
    const [nomePai, setNomePai] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [uf, setUf] = useState('');
    const [naturalidade, setNaturalidade] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cep, setCep] = useState('');
    const [ufsDisponiveis, setUfsDisponiveis] = useState([]); 
    const [cidades, setCidades] = useState([]); 
    const [errorMessage, setErrorMessage] = useState('');
    const [ufErrorMessage, setUfErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState(false);
    const [orgaoExpeditor, setOrgaoExpeditor] = useState('');
    const [dataExpedicao, setDataExpedicao] = useState('');
    const [estadoComarca, setEstadoComarca] = useState('');
    const [comarcas, setComarcas] = useState([]);
    const [comarca, setComarca] = useState('');
    const [ufExpedicao, setUfExpedicao] = useState('');
    const navigate = useNavigate();

    function validateCpf(cpf) {
    const cleaned = cpf.replace(/\D/g, '');
    if (cleaned.length !== 11 || /^([0-9])\1{10}$/.test(cleaned)) return false;

    const calcCheckDigit = (digits) => {
        const sum = digits
        .split('')
        .reduce((acc, num, idx) =>
            acc + parseInt(num, 10) * ((digits.length + 1) - idx), 0
        );
        const mod = sum % 11;
        return mod < 2 ? 0 : 11 - mod;
    };

    const d1 = calcCheckDigit(cleaned.slice(0, 9));
    const d2 = calcCheckDigit(cleaned.slice(0, 9) + d1);
    return d1 === +cleaned[9] && d2 === +cleaned[10];
    }

    // Valida RG — apenas dígitos entre 5 e 9 caracteres
    function validateRg(rg) {
        const alphanumeric = rg.replace(/[^a-zA-Z0-9]/g, '');
        return alphanumeric.length >= 5 && alphanumeric.length <= 15;
    }

    useEffect(() => {
        AuthService.fetchUFs()
            .then((data) => {
                const ufsOrdenados = data.sort();
                setUfsDisponiveis(ufsOrdenados);
            })
            .catch((error) => setErrorMessage('Erro ao carregar estados: ' + error.message));
    }, []);

    useEffect(() => {
        console.log("User has been updated:", user);
    }, [user]);

    const handleUfChange = (selectedUf) => {
        setUf(selectedUf);

        if (!selectedUf) {
            setCidades([]);
            setNaturalidade('');
            setUfErrorMessage('Selecione o UF antes de escolher a cidade');
            return;
        } else {
            setUfErrorMessage('');
        }

        AuthService.fetchCidadesPorUf(selectedUf)
            .then((data) => {
                setCidades(data);
                setNaturalidade('');
            })
            .catch((error) => setErrorMessage('Erro ao carregar cidades: ' + error.message));
    };

    const handleNaturalidadeChange = (event) => {
        setNaturalidade(event.target.value);
    };

    const formatCpf = (value) => {
        value = value.replace(/\D/g, ''); 
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
    };

    const formatRg = (value) => {
        value = value.replace(/[.\-\/]/g, '');
        if (value.length > 15) value = value.slice(0, 15);
        return value;
    };

    const handleEstadoComarcaChange = (ufSelecionado) => {
        setEstadoComarca(ufSelecionado);
        if (!ufSelecionado) {
            setComarcas([]);
            setComarca('');
            return;
        }

        AuthService
            .fetchComarcasPorEstado(ufSelecionado)
            .then(response => {
            const lista = response.comarcas || [];
            if (lista.length === 0) {
                // se não veio nada, mostramos só "Não é Necessário"
                setComarcas(['Não é Necessário']);
                setComarca('Não é Necessário');
            } else {
                setComarcas(lista);
                setComarca(''); // força o usuário a escolher
            }
            })
            .catch(err => {
            setErrorMessage('Erro ao carregar comarcas: ' + err.message);
            });
        };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("O evento handleSubmit foi acionado");
        console.log("Current user on submit:", user);
        console.log("Certificados Selecionados:", certificadosSelecionados);
    
        if (!validateCpf(cpf)) {
            setErrorMessage('CPF inválido.');
            return;
        }

        if (!validateRg(rg)) {
            setErrorMessage('RG inválido.');
            return;
        }
    
        if (!uf) {
            setUfErrorMessage('Selecione o UF antes de continuar.');
            return;
        }
        
        const certificados = certificadosSelecionados.flatMap(certificado => ({
            regiao: certificado.estado,
            model_id: certificado.certidao_id
        }));
        
        console.log("Certificados processados após simplificação:", certificados);
    
        if (certificados.length === 0) {
            setErrorMessage('Nenhum certificado selecionado.');
            return;
        }

        if (!estadoCivil) {
        setErrorMessage('Selecione o estado civil.');
        return;
        }

        if (!ufExpedicao) {
        setErrorMessage('Selecione a UF de expedição do RG.');
        return;
        }

        let dataFormatadaExp = '';
        if (dataExpedicao) {
        const [anoE, mesE, diaE] = dataExpedicao.split('-');
        dataFormatadaExp = `${diaE}${mesE}${anoE}`;
        }

        console.log("Current user object:", user);

        const [ano, mes, dia] = dataNascimento.split('-');
        const dataFormatada = `${dia}${mes}${ano}`;

        const payload = {
            determination: certificados,
            user_id: user?.user?.id,
            tipo_pessoa: 'F',
            nome_completo: nomeCompleto,
            genero: genero === 'Masculino' ? 'M' : 'F',
            cpf: cpf.replace(/\D/g, ''),
            rg: rg.trim(),
            estado_civil: estadoCivil,
            nome_mae: nomeMae,
            nome_pai: nomePai,
            data_nascimento: dataFormatada,
            uf: uf,
            naturalidade: naturalidade,
            orgao_expeditor: orgaoExpeditor,
            uf_expedicao: ufExpedicao,
            data_expedicao: dataFormatadaExp,
            comarca: comarca,
            logradouro: logradouro,
            numero: numero,
            complemento: complemento,
            bairro: bairro,
            estado: uf,
            cep: cep.replace(/\D/g, ''),
        };

        console.log("Payload a ser enviado:", payload);
    
        try {
            console.log('Tentando enviar o formulário...');
            const response = await AuthService.enviarFormularioSP(payload);
            console.log('Formulário enviado com sucesso:', response.data);
        
            // Exibe o modal de sucesso
            setSuccessMessage(true);
            setTimeout(() => {
                setSuccessMessage(false);
                // Redireciona para o dashboard
                navigate('/home/dashboard');
            }, 3000); // 5 segundos de exibição
        } catch (error) {
            setErrorMessage('Erro ao enviar o formulário: ' + error.message);
        
            // Mesmo em caso de erro, exibe o modal e redireciona
            setSuccessMessage(true);
            setTimeout(() => {
                setSuccessMessage(false);
                // Redireciona para o dashboard
                navigate('/home/dashboard');
            }, 3000); // 5 segundos de exibição
        }
    };

    return (
        <div className={styles.formContainer}>
            <h4>Formulário Pessoa Física</h4>
            {errorMessage && (
            <p className={styles.errorMessage}>{errorMessage}</p>
            )}
            <form onSubmit={handleSubmit}>
                {/* Nome Completo */}
                <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                    <label htmlFor="nomeCompleto"></label>
                    <input
                        type="text"
                        id="nomeCompleto"
                        value={nomeCompleto}
                        onChange={(e) => setNomeCompleto(e.target.value)}
                        placeholder="Nome Completo"
                        required
                    />
                </div>

                {/* CPF e RG */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="cpf"></label>
                        <input
                            type="text"
                            id="cpf"
                            value={cpf}
                            onChange={(e) => setCpf(formatCpf(e.target.value))}
                            maxLength="14"
                            placeholder="CPF"
                            required
                        />
                    </div>
                    <div className={styles.halfWidth}>
                        <label htmlFor="rg"></label>
                        <input
                            type="text"
                            id="rg"
                            value={rg}
                            onChange={(e) => setRg(formatRg(e.target.value))}
                            maxLength="15"
                            placeholder="RG"
                            required
                        />
                    </div>
                </div>

                {/* Data de Nascimento e Gênero */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="dataNascimento"></label>
                        <input
                            id="dataNascimento"
                            // enquanto não há valor, mostramos o placeholder
                            type={dataNascimento ? 'date' : 'text'}
                            placeholder="Data de Nascimento"
                            required
                            value={dataNascimento}
                            onFocus={e => e.target.type = 'date'}  
                            onBlur={e => !e.target.value && (e.target.type = 'text')}
                            onChange={e => setDataNascimento(e.target.value)}
                        />
                    </div>

                    <div className={styles.halfWidth}>
                        <label></label>
                        <div className={styles.genderContainer}>
                            <button
                                type="button"
                                className={`${styles.genderButton} ${genero === 'Masculino' ? styles.selected : ''}`}
                                onClick={() => setGenero('Masculino')}
                            >
                                Masculino
                            </button>
                            <button
                                type="button"
                                className={`${styles.genderButton} ${genero === 'Feminino' ? styles.selected : ''}`}
                                onClick={() => setGenero('Feminino')}
                            >
                                Feminino
                            </button>
                        </div>
                    </div>
                </div>

                {/* Nome da Mãe e Nome do Pai */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="nomeMae"></label>
                        <input
                            type="text"
                            id="nomeMae"
                            value={nomeMae}
                            onChange={(e) => setNomeMae(e.target.value)}
                            placeholder="Nome da Mãe"
                            required
                        />
                    </div>
                    <div className={styles.halfWidth}>
                        <label htmlFor="nomePai"></label>
                        <input
                            type="text"
                            id="nomePai"
                            value={nomePai}
                            onChange={(e) => setNomePai(e.target.value)}
                            placeholder="Nome do Pai"
                        />
                    </div>
                </div>

                {/* UF e Naturalidade */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="uf"></label>
                        <select
                            id="uf"
                            value={uf}
                            onChange={(e) => handleUfChange(e.target.value)}
                            placeholder="UF"
                            required
                        >
                            <option value="">Selecione o estado</option>
                            {ufsDisponiveis.map((uf, index) => (
                                <option key={index} value={uf}>
                                    {uf}
                                </option>
                            ))}
                        </select>
                        {ufErrorMessage && <p style={{ color: 'red' }}>{ufErrorMessage}</p>}
                    </div>

                    <div className={styles.halfWidth}>
                        <label htmlFor="naturalidade"></label>
                        <select
                            id="naturalidade"
                            value={naturalidade}
                            onChange={(e) => setNaturalidade(e.target.value)}
                            required
                            disabled={!uf}
                            placeholder="Naturalidade"
                        >
                            <option value="">Selecione a cidade</option>
                            {cidades.map((cidadeObj) => (
                                <option key={cidadeObj.id_estado} value={cidadeObj.id_estado}>
                                    {cidadeObj.cidade}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Orgão Expeditor, UF Expedição e Data de Expedição */}
                <div className={styles.formGroup}>
                {/* 1. Órgão Expeditor */}
                <div className={styles.thirdWidth}>
                    <label htmlFor="orgaoExpeditor"></label>
                    <input
                    type="text"
                    id="orgaoExpeditor"
                    value={orgaoExpeditor}
                    onChange={e => setOrgaoExpeditor(e.target.value)}
                    placeholder="Orgão Expeditor"
                    />
                </div>

                {/* 2. UF de Expedição do RG */}
                <div className={styles.thirdWidth}>
                    <label htmlFor="ufExpedicao"></label>
                    <select
                    id="ufExpedicao"
                    value={ufExpedicao}
                    onChange={e => setUfExpedicao(e.target.value)}
                    required
                    >
                    <option value="">UF Emissão do RG</option>
                    {ufsDisponiveis.map(uf => (
                        <option key={uf} value={uf}>{uf}</option>
                    ))}
                    </select>
                </div>

                {/* 3. Data de Expedição */}
                <div className={styles.thirdWidth}>
                    <label htmlFor="dataExpedicao"></label>
                    <input
                    id="dataExpedicao"
                    type={dataExpedicao ? 'date' : 'text'}
                    placeholder="Data de Expedição (RG)"
                    value={dataExpedicao}
                    onFocus={e => e.target.type = 'date'}
                    onBlur={e => !e.target.value && (e.target.type = 'text')}
                    onChange={e => setDataExpedicao(e.target.value)}
                    />
                </div>
                </div>

                {/* Estado Civil */}
                <div className={styles.formGroup}>
                <div className={styles.fullWidth}>
                    <label htmlFor="estadoCivil"></label>
                    <select
                    id="estadoCivil"
                    value={estadoCivil}
                    onChange={e => setEstadoCivil(e.target.value)}
                    required
                    >
                    <option value="">Selecione o Estado Civil</option>
                    <option value="Casado">Casado</option>
                    <option value="Divorciado">Divorciado</option>
                    <option value="Separado Judicialmente">Separado Judicialmente</option>
                    <option value="Solteiro">Solteiro</option>
                    <option value="União Estável">União Estável</option>
                    <option value="Viúvo">Viúvo</option>
                    <option value="Outros">Outros</option>
                    </select>
                </div>
                </div>

                {/* Estado da Comarca e Comarca */}
                <div className={styles.formGroup}>
                <div className={styles.halfWidth}>
                    <label htmlFor="estadoComarca"></label>
                    <select
                    id="estadoComarca"
                    value={estadoComarca}
                    onChange={e => handleEstadoComarcaChange(e.target.value)}
                    required
                    >
                    <option value="">Estado da Comarca</option>
                    {ufsDisponiveis.map(uf => (
                        <option key={uf} value={uf}>{uf}</option>
                    ))}
                    </select>
                </div>

                <div className={styles.halfWidth}>
                    <label htmlFor="comarca"></label>
                    <select
                    id="comarca"
                    value={comarca}
                    onChange={e => setComarca(e.target.value)}
                    required
                    disabled={!comarcas.length}
                    >
                    {comarcas[0] !== 'Não é Necessário' && (
                        <option value="">Selecione a comarca</option>
                    )}
                    {comarcas.map(c => (
                        <option key={c} value={c}>{c}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Logradouro, Número e Complemento */}
                <div className={styles.formGroup}>
                    <div className={styles.thirdWidth}>
                        <label htmlFor="logradouro"></label>
                        <input
                            type="text"
                            id="logradouro"
                            value={logradouro}
                            onChange={(e) => setLogradouro(e.target.value)}
                            placeholder="Logradouro"
                        />
                    </div>
                    <div className={styles.thirdWidth}>
                        <label htmlFor="numero"></label>
                        <input
                            type="text"
                            id="numero"
                            value={numero}
                            onChange={(e) => setNumero(e.target.value)}
                            placeholder="Número"
                        />
                    </div>
                    <div className={styles.thirdWidth}>
                        <label htmlFor="complemento"></label>
                        <input
                            type="text"
                            id="complemento"
                            value={complemento}
                            onChange={(e) => setComplemento(e.target.value)}
                            placeholder="Complemento"
                        />
                    </div>
                </div>

                {/* Bairro e CEP */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="bairro"></label>
                        <input
                            type="text"
                            id="bairro"
                            value={bairro}
                            onChange={(e) => setBairro(e.target.value)}
                            placeholder="Bairro"
                        />
                    </div>
                    <div className={styles.halfWidth}>
                        <label htmlFor="cep"></label>
                        <input
                            type="text"
                            id="cep"
                            value={cep}
                            onChange={(e) => setCep(e.target.value)}
                            placeholder="CEP"
                        />
                    </div>
                </div>

                <button type="submit">Enviar</button>
            </form>

            {successMessage && (
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        <p>Solicitado com sucesso!</p>
                    </div>
                </div>
            )}

        </div>
    );
};

export default FormSPFisico;
